var meta={showLeftMenu:true,headIndex:3,keepAlive:true};
export var router = [{
path: '/knowledgeGraph',
meta:{showLeftMenu:false,headIndex:3,keepAlive:true,changed:false,isBack:false},
name:'knowledgeGraph',
component: resolve => require(["./knowledgeGraph.vue"],resolve),
},
// {
// path: '/knowledgeGraph/feedback',
// meta:{showLeftMenu:false,headIndex:3,keepAlive:false,changed:false,isBack:false},
// name:'feedback',
// component: resolve => require(["./feedback.vue"],resolve),
// },
{
path: '/feedback',
meta:{showLeftMenu:false,headIndex:3,keepAlive:true,changed:false,isBack:false},
name:'feedback',
component: resolve => require(["./feedback.vue"],resolve),
},
{
path: '/detail',
meta:{showLeftMenu:false,headIndex:3,keepAlive:false,changed:false,isBack:false},
name:'detail',
component: resolve => require(["./versionDetail.vue"],resolve),
}]


// WEBPACK FOOTER //
// ./src/views/knowledgeGraph/router.js